import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB5cAkTH9fGrk-aKWPvE6oN4JVdn0wRn_I",
    authDomain: "whizzapp-83b47.firebaseapp.com",
    projectId: "whizzapp-83b47",
    storageBucket: "whizzapp-83b47.appspot.com",
    messagingSenderId: "175531267037",
    appId: "1:175531267037:web:5b6256c53459bf7b721c34",
    measurementId: "G-PWEEK27WY7"
};

export const recaptchaVerifier = firebase.auth.RecaptchaVerifier;
// Facebook login
let FacebookProvider = new firebase.auth.FacebookAuthProvider();

export const SignInWithFacebook = () => {
    return firebase.auth().signInWithRedirect(FacebookProvider);
  };

firebase.initializeApp(firebaseConfig);

// Google login
const GoogleProvider = new firebase.auth.GoogleAuthProvider();

export const SignInWithGoogle = () => {
  return firebase.auth().signInWithRedirect(GoogleProvider);
};
// const updateUserInfo = async (updatedUser) => {
//     firebase.firestore().collection('users').doc(user.uid).set({...updatedUser}).then(userInfo => {
//         setUserInfo(updatedUser);
        
//     }).catch(err => {
//     });
// }
export default firebase;